import { ComposeOperation } from 'mini-mail-compose-store';
import { ComposeViewStateInitProps } from 'mini-mail-compose-store/lib/utils/createComposeViewState';
import { lazyNewMessageErrorHandled } from 'mini-mail-compose-actions-mail';

export const composeEmail = async (
    props: Omit<ComposeViewStateInitProps, 'operation'>
): Promise<void> => {
    await lazyNewMessageErrorHandled({ operation: ComposeOperation.New, ...props });
};
